// Sentry API Log
import * as Sentry from '@sentry/react';
import { gtm, fatalErrorEvent } from '~/common/utils/tracking.js';

const parsedMessage = (errObj) => {
    const err = errObj;
    const resp = err.response;

    let PAPIErrorCode = resp.data.statusCode;
    let PAPIErrorType = resp.data.error;
    let PAPIErrorCause = resp.data.message;

    // Geneal Error Message Assignment
    if (resp.data && resp.data.Details) {
        PAPIErrorCode = resp.data.Details[0].ErrorCode || 'No Code';
        PAPIErrorType = resp.data.ErrorType || 'No Type';
        PAPIErrorCause = resp.data.Details[0].Cause || 'No Cause';

        // Pending Signup Message Formatting
        if (resp.data.Details[0].AdditionalMessage && resp.data.Details[0].AdditionalMessage.indexOf('reference order number') > -1) {
            PAPIErrorCause = 'Pending Signup';
        }
    }

    const msg = `${PAPIErrorCode} | ${PAPIErrorType} | ${PAPIErrorCause}`;
    return msg;
};

const LogPAPIError = (errObj, level = 'fatal') => {
    const err = errObj;
    const extra = err.response;
    const errorCode = extra?.data?.statusCode;
    let errLevel = level;
    if (extra.data && extra.data.Details) {
        errLevel = 'error';
    }

    // call gtm fatal error event for 400 or 500 codes
    if (errorCode && `${errorCode}`.length === 3 && (`${errorCode}`.charAt(0) === '4' || `${errorCode}`.charAt(0) === '5')) {
        gtm(fatalErrorEvent(extra.data.message));
    }

    return Sentry.captureMessage(parsedMessage(err), { extra, level: errLevel });
};

export default LogPAPIError;
